import Banner from '@luna-protocol/core/src/components/Banner/Banner';
import Body from '@luna-protocol/core/src/components/Body/Body';
import { FormattedMessage, useIntl } from 'react-intl';
import messages from './PricingError.messages';
import { NavLink } from 'react-router-dom';
import Button from '@luna-protocol/core/src/components/Button/Button';

const PricingError = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <Banner>{formatMessage(messages.title)} </Banner>
      <Body>
        <p>
          <FormattedMessage
            id={messages.detail1.id}
            values={{
              bold: chunks => <b>{chunks}</b>,
            }}
          />
        </p>
        <NavLink to={'/prequalification'}>
          <Button>{formatMessage(messages.continue)}</Button>
        </NavLink>
      </Body>
    </>
  );
};

export default PricingError;
